import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useAuth } from '../../contexts/AuthContext'
import { authApi } from '../../services/api/auth'

export default function AccountRejectedPage() {
  const { user, refreshToken } = useAuth()
  const navigate = useNavigate()
  const [submitting, setSubmitting] = useState(false)

  const handleReRequest = async () => {
    setSubmitting(true)
    try {
      await authApi.reRequestAccess()
      // Refresh the user object so approval_status flips to PENDING in context,
      // then the StatusRoute will route to /pending-approval automatically.
      const refreshed = await refreshToken()
      if (refreshed) {
        navigate('/pending-approval', { replace: true })
      } else {
        navigate('/login', { replace: true })
      }
      toast.success('Request submitted. An administrator will review it.')
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Could not submit request')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
          Access declined
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Your request to access the BK Profile System was declined. If you believe this is
          a mistake, you can request access again below.
        </p>

        {user?.rejection_reason && (
          <div className="text-left bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800
                          rounded-lg p-4 mb-6">
            <div className="text-xs uppercase tracking-wide text-red-700 dark:text-red-300 mb-1">
              Reason
            </div>
            <div className="text-sm text-red-900 dark:text-red-200">{user.rejection_reason}</div>
          </div>
        )}

        <div className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          Account: {user?.email}
        </div>

        <button
          onClick={handleReRequest}
          disabled={submitting}
          className="w-full px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-50
                     text-white font-medium transition-colors"
        >
          {submitting ? 'Submitting…' : 'Request access again'}
        </button>
      </div>
    </div>
  )
}
